export default __webpack_public_path__ + "static/media/Search icon.d949d322.svg";